import React, { Component } from "react";
import "react-moment";
import moment from "moment";
import ReporteComprasSire from "./ReporteComprasSire";
import ReporteVentasSire from "./ReporteVentasSire";

class DashboardSire extends Component {
    constructor(props){
        super(props);
        this.state = {
            loadedSections: {
                reporteCompras: false,
                reporteVentas: false
            },
            loadingSections: {
                reporteCompras: false,
                reporteVentas: false
            }
        };

        this.timeoutRefs = {
            reporteCompras: null,
            reporteVentas: null
        };
    }

    componentDidMount() {
        // Se mantiene sin carga inicial para seguir el patron del NuevoDashboard.
    }

    componentWillUnmount() {
        Object.values(this.timeoutRefs).forEach(timeout => {
            if (timeout) clearTimeout(timeout);
        });
    }

    handleAccordionToggle(section, isExpandig) {
        if (this.timeoutRefs[section]){
            clearTimeout(this.timeoutRefs[section]);
        }

        if (isExpandig && !this.state.loadedSections[section]){
            this.setState(prevState => ({
                loadingSections: {
                    ...prevState.loadingSections,
                    [section]: true
                }
            }));

            this.timeoutRefs[section] = setTimeout(() => {
                this.loadSectionData(section);
            }, 800);
        }
    }

    async loadSectionData(section) {
        try {
            // await this.getVentas();
            // await this.getCompras();
            
            this.setState(prevState => ({
                loadedSections: {
                    ...prevState.loadedSections,
                    [section]: true
                },
                loadingSections: {
                    ...prevState.loadingSections,
                    [section]: false
                }
            }));

        } catch (error) {
            console.error(`Error loading ${section}:`, error);
            this.setState(prevState => ({
                loadingSections: {
                    ...prevState.loadingSections,
                    [section]: false
                }
            }));
        }
    }

    render() {
        const { loadedSections, loadingSections } = this.state;
        
        return (
            <section className="ventas-fpay-section-vh">
                <div className="container-fluid px-md-5">
                    <div className="mb-2 pt-3">
                        <h4 className="mt-2 text-center">REPORTE GENERALES SIRE</h4>
                        <div className="accordion pb-5" id="accordionExample">
                            
                            <div className="abed__card-dashboard">
                                <div className="abed__card-header" id="headingOne">
                                    <h2 className="mb-0 text-center">
                                        <button
                                            className="btn"
                                            type="button"
                                            data-toggle="collapse"
                                            data-target="#collapseOne"
                                            aria-expanded="true"
                                            aria-controls="collapseOne"
                                            style={{ width: '100%' }}
                                            onClick={() => this.handleAccordionToggle('reporteCompras', true)}
                                        >
                                            REPORTE SIRE DE COMPRAS
                                        </button>
                                    </h2>
                                </div>
                                <div className="collapse show" id="collapseOne" 
                                    aria-labelledby="headingOne" data-parent="#accordionExample">
                                    <div className="card-body">
                                        {loadingSections.reporteCompras ? (
                                            <div className="text-center py-3">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Cargando...</span>
                                                </div>
                                                <p className="mt-2">Cargando reporte de compras...</p>
                                            </div>
                                        ) : loadedSections.reporteCompras ? (
                                            <div className="reporte-container">
                                                <ReporteComprasSire />
                                            </div>
                                        ) : (
                                            <div className="text-center py-3 text-muted">
                                                <i className="fas fa-chart-pie fa-2x mb-2"></i>
                                                <p>Expande para cargar el reporte de compras</p>
                                            </div>
                                        )} 
                                    </div>
                                </div>
                            </div>

                            <div className="abed__card-dashboard mt-3">
                                <div className="abed__card-header" id="headingTwo">
                                    <h2 className="mb-0 text-center">
                                        <button
                                            className="btn collapsed"
                                            type="button"
                                            data-toggle="collapse"
                                            data-target="#collapseTwo"
                                            aria-expanded="false"
                                            aria-controls="collapseTwo"
                                            style={{ width: '100%' }}
                                            onClick={() => this.handleAccordionToggle('reporteVentas', true)}
                                        >
                                            REPORTE SIRE DE VENTAS
                                        </button>
                                    </h2>
                                </div>
                                <div className="collapse" id="collapseTwo"
                                    aria-labelledby="headingTwo" data-parent="#accordionExample">
                                    <div className="card-body">
                                        {loadingSections.reporteVentas ? (
                                            <div className="text-center py-3">
                                                <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Cargando...</span>
                                                </div>
                                                <p className="mt-2">Cargando reporte de ventas...</p>
                                            </div>
                                        ) : loadedSections.reporteVentas ? (
                                            <div className="reporte-container">
                                                <ReporteVentasSire />
                                            </div>
                                        ) : (
                                            <div className="text-center py-3 text-muted">
                                                <i className="fas fa-chart-line fa-2x mb-2"></i>
                                                <p>Expande para cargar el reporte de ventas</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default DashboardSire;